import React, { useEffect, useState } from 'react';
import Sidebar from './components/Sidebar';
import Navigation from './components/Navigation';
import base_url from './config/Config'; // Assuming base_url is set in your config

const Profile = () => {
  const [userData, setUserData] = useState({
    employeeName: '',
    spocMobileNumber: '',
    emailId: ''
  });

  useEffect(() => {
    const fetchUserData = async () => {
      try {
        const response = await fetch(`${base_url}/api1/customer/userListById?id=1`);
        if (response.ok) {
          const data = await response.json();
          setUserData({
            employeeName: data.employeeName || '',            // Ensure field names match API response
            spocMobileNumber: data.spocMobileNumber || '',
            emailId: data.emailId || '',
            partnerAccountNumber: data.partnerAccountNumber || '',            // Ensure field names match API response
            directorAadhar: data.directorAadhar || '',
            gstNumber: data.gstNumber || '',
            cinNumber: data.cinNumber || '',            // Ensure field names match API response
            pan: data.pan || '',
            status: data.status || ''
          });
        } else {
          console.error('Failed to fetch user data:', response.statusText);
        }
      } catch (error) {
        console.error('Error fetching user data:', error.message);
      }
    };

    fetchUserData();
  }, []); // Empty dependency array ensures this runs only once

  return (
    <>
      <div className='overviewsaa'>
        <h4>Profile Details</h4>
      </div>
      <div className='navigationss mb-5'>
        <Navigation />
      </div>
      <div className='container-fluid'>
        <div className='row'>
          <div className='col-lg-2 col-md-2 sidebarnavigartion'>
            <div className='lmssidebar'>
              <Sidebar />
            </div>
          </div>
          <div className='col-md-10 mt-5 '>
            <div className='dashboardlms'>
            <div className='row'>
              <div className='col-md-4 text-center'>
                <div className='personaldetails text-justify mt-3'>
                  <label htmlFor="fintech_name">Fintech Name</label><br />
                  <input type="text" id="fintech_name" value={userData.employeeName} readOnly />
                </div>
              </div>
              <div className='col-md-4 text-center'>
                <div className='personaldetails text-justify mt-3'>
                  <label htmlFor="spoc_mobile_number">Phone Number</label><br />
                  <input type="text" id="spoc_mobile_number" value={userData.spocMobileNumber} readOnly />
                </div>
              </div>
              <div className='col-md-4 text-center'>
                <div className='personaldetails text-justify mt-3'>
                  <label htmlFor="email_id">Email</label><br />
                  <input type="text" id="email_id" value={userData.emailId} readOnly />
                </div>
              </div>
              <div className='col-md-4 text-center'>
                <div className='personaldetails text-justify mt-3'>
                  <label htmlFor="email_id">Pan Number</label><br />
                  <input type="text" id="email_id" value={userData.pan} readOnly />
                </div>
              </div>
              <div className='col-md-4 text-center'>
                <div className='personaldetails text-justify mt-3'>
                  <label htmlFor="email_id">Aadhar Number</label><br />
                  <input type="text" id="email_id" value={userData.directorAadhar} readOnly />
                </div>
              </div>
              <div className='col-md-4 text-center'>
                <div className='personaldetails text-justify mt-3'>
                  <label htmlFor="email_id">Cin Number</label><br />
                  <input type="text" id="email_id" value={userData.cinNumber} readOnly />
                </div>
              </div>
              <div className='col-md-4 text-center'>
                <div className='personaldetails text-justify mt-3'>
                  <label htmlFor="email_id">Account Number</label><br />
                  <input type="text" id="email_id" value={userData.partnerAccountNumber} readOnly />
                </div>
              </div>
              <div className='col-md-4 text-center'>
                <div className='personaldetails text-justify mt-3'>
                  <label htmlFor="email_id">GST Number</label><br />
                  <input type="text" id="email_id" value={userData.gstNumber} readOnly />
                </div>
              </div>
              
              <div className='col-md-4 text-center'>
                <div className='personaldetails text-justify mt-3'>
                  <label htmlFor="email_id">Status</label><br />
                  <input type="text" id="email_id" value={userData.status} readOnly />
                </div>
              </div>
            </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Profile;
